import { AxiosResponse } from 'axios';
import { create } from 'zustand';
import { CreateCustomSegmentDTO, FilterData, ResponseSegmentItems } from './types';

type State = {
  openModalCreateEditSegment: boolean;
  openModalRemoveSegment: boolean;
  customSegmentData: AxiosResponse;
  segmentActionType: 'create' | 'edit';
  saveSegmentBody: CreateCustomSegmentDTO;
  selectedSegmentID: number | null;
  chainFilterData: FilterData;
};

type Actions = {
  setSetupISACustomSegmentsState: (name: string, data: any) => void;
  setCreateEditSegmentOpenModal: (type: 'create' | 'edit', open: boolean) => void;
  setCreateEditSegmentCloseModal: () => void;
  setEditSegmentData: (id: number) => void;
  reset: () => void;
};

const initialState: State = {
  openModalCreateEditSegment: false,
  openModalRemoveSegment: false,
  customSegmentData: {
    data: [],
    status: 0,
    statusText: '',
    headers: {},
    config: {} as any,
  } as AxiosResponse<ResponseSegmentItems[]>,
  saveSegmentBody: {
    nomeSegmento: '',
    codigoSegmento: '',
    tipoSegmento: '',
    itens: [],
  },
  segmentActionType: 'create',
  selectedSegmentID: null,
  chainFilterData: {
    list: [],
    cache: [],
    value: [],
  },
};

export const useSetupISACustomSegmentsStore = create<State & Actions>(set => ({
  ...initialState,
  setSetupISACustomSegmentsState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  setCreateEditSegmentOpenModal: (type, open) => {
    set(() => ({
      openModalCreateEditSegment: open,
      segmentActionType: type,
    }));
  },
  setCreateEditSegmentCloseModal: () => {
    set(() => ({
      openModalCreateEditSegment: false,
      segmentActionType: 'create',
      saveSegmentBody: initialState.saveSegmentBody,
      selectedSegmentID: null,
      chainFilterData: initialState.chainFilterData,
    }));
  },
  setEditSegmentData: id => {
    function setData(segmentID: number, data: AxiosResponse<ResponseSegmentItems[]>) {
      const segment = data?.data?.content?.find(segment => segment.segmento.id === segmentID);

      if (!segment) {
        return {
          saveSegmentBody: {
            nomeSegmento: '',
            codigoSegmento: '',
            tipoSegmento: 'REDE',
            itens: [],
          },
          chainFilterData: {
            list: [],
            cache: [],
            value: [],
          },
        };
      }

      const items =
        segment.itens?.map(item => ({
          label: item.nomeItem,
          value: item.nomeItem,
        })) || [];

      const itemsValue = segment.itens?.map(item => item.nomeItem) || [];

      const saveData = {
        nomeSegmento: segment.segmento.nomeSegmento,
        codigoSegmento: '',
        tipoSegmento: 'REDE',
        itens: itemsValue,
      };

      const chainData = {
        list: items,
        cache: items,
        value: itemsValue,
      };

      return {
        saveSegmentBody: saveData,
        chainFilterData: chainData,
      };
    }

    set(state => {
      const result = setData(id, state.customSegmentData);
      return {
        chainFilterData: result.chainFilterData,
        saveSegmentBody: result.saveSegmentBody,
        selectedSegmentID: id,
        segmentActionType: 'edit',
        openModalCreateEditSegment: true,
      };
    });
  },
  reset: () => {
    set(initialState);
  },
}));
